
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ProductSelectGridForMaterialIn extends Serenity.EntityGrid<ProductMasterRow, any> {
        protected getColumnsKey() { return 'OMS.ProductMaster'; }
        protected getDialogType() { return <any>ProductMasterDialog; }
        protected getIdProperty() { return ProductMasterRow.idProperty; }
        protected getLocalTextPrefix() { return ProductMasterRow.localTextPrefix; }
       // protected getService() { return ProductMasterService.baseUrl; }
        //protected getInsertPermission() { return ProductMasterRow.insertPermission; }
        //protected getUpdatePermission() { return ProductMasterRow.updatePermission; }
        //protected getDeletePermission() { return ProductMasterRow.deletePermission; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        static ItemType: number;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            
            if (ProductSelectGridForMaterialIn.ItemType == 2) {
                var newCols = columns.filter(x => x.field != "Weight");
                newCols = newCols.filter(x => x.field != "NetWeight");
                newCols = newCols.filter(x => x.field != "Price");
                newCols = newCols.filter(x => x.field != "UserDescription");
                columns = newCols;

            }
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize);
            
            let x;
            if (ProductSelectGridForMaterialIn.ItemType.toString() == "1") {
                ProductMasterService.CustomList({
                    ItemTypeIds: [101]
                },
                    response =>
                        x = response,
                    { async: false });

            } else if (ProductSelectGridForMaterialIn.ItemType.toString() == "2") {
                ProductMasterService.CustomList({
                    ItemTypeIds: [104,105]
                },
                    response =>
                        x = response,
                    { async: false });

            }
            let y = [];
            for (let temp of x.Entities) {
                let ATBDetails = temp;
                var Product: ProductMasterRow = {
                    Attribute: temp.Attribute,
                    AttributeId: temp.AttributeId,
                    ProductTypeId: ATBDetails.ProductTypeId,
                    ProductTypeName: ATBDetails.ProductTypeName,
                    BOMDetails: temp.BOMDetails,
                    BrandId: ATBDetails.BrandId,
                    CalcOnId: temp.CalcOnId,
                    CalcUnitId: temp.CalcUnitId,
                    CollectionId: temp.CollectionId,
                    DiamondPieces: temp.DiamondPieces,
                    DiamondWeight: temp.DiamondWeight,
                    HasBom: temp.HasBom,
                    HSN: temp.HSN,
                    Image1: temp.Image1,
                    Image2: temp.Image2,
                    Image3: temp.Image3,
                    ImageName: temp.ImageName,
                    IsDisabled: temp.IsDisabled,
                    ItemTypeId: temp.ItemTypeId,
                    KaratId: ATBDetails.KaratId,
                    MetalId: temp.MetalId,
                    NetWeight: temp.NetWeight,
                    OtherPieces: temp.OtherPieces,
                    OtherWeight: temp.OtherWeight,
                    Pieces: temp.Pieces,
                    ProductCode: temp.ProductCode,
                    ProductId: temp.ProductId,
                    ProductName: temp.ProductName,
                    Rate: temp.Rate,
                    Remarks: temp.Remarks,
                    ServerDate: temp.ServerDate,
                    Purity: temp.Purity,
                    StonePieces: temp.StonePieces,
                    StoneWeight: temp.StoneWeight,
                    SubCategoryId: ATBDetails.SubCategoryId,
                    SubCategoryName: ATBDetails.SubCategoryName,
                    SuperTypeId: ATBDetails.SuperTypeId,
                    CategoryId: ATBDetails.CategoryId,
                    CategoryName: ATBDetails.CategoryName,
                    Weight: temp.Weight
                    

                };
                y.push(Product);
            }
            let x1;
            let nextId = 1;
            for (let product of y) {
                product[this.getIdProperty()] = product.ProductId;
                //   alert('ID ' + rateitem.CostId);

                this.view.addItem(product);
            }
            //grid.setData(x1, true);
            //var c = grid.getData();



            return grid;
        }

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): ProductMasterRow[] {
            var _this = this;
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    }

    export interface ProductSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}